import { render, staticRenderFns } from "./FormDataPreview.vue?vue&type=template&id=2106dabf&"
import script from "./FormDataPreview.vue?vue&type=script&lang=js&"
export * from "./FormDataPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports